import { MappingItem } from '@corratech/pylot-gtm/src/GTM'
import { pdpCartItemMapping } from 'stores/ooka_usa_store/components/OOKA/pylot-gtm/src/mapping/events/pdpCartItemMapping'

export const pdpAddToCartProductsData = (
    itemMapping = pdpCartItemMapping()
): MappingItem => {
    return {
        added_items: {
            data_source: ['updatedItems'],
            mapping: itemMapping,
            strict: true
        }
    }
}
